'use client';

import { useEffect } from 'react';

import { Trans } from '@kit/ui/trans';

import {
  openTenantAnalyticsConsentPreferences,
  useRegisterCookieSettingsLink,
} from './tenant-analytics-consent-preferences';

/**
 * Footer entry point into the consent preferences sheet. Rendered
 * unconditionally: the sheet itself only mounts when the tenant has analytics
 * configured, and a click with no sheet mounted is a harmless no-op event.
 *
 * A button, not an anchor — it opens a panel rather than navigating.
 *
 * While mounted it registers itself, which stands the floating launcher down —
 * the launcher exists only for surfaces that have no footer link of their own
 * (the ~13 bespoke tenant footers, and native where the footer is suppressed).
 */
export function TenantCookieSettingsLink({
  className,
}: {
  className?: string;
}) {
  const register = useRegisterCookieSettingsLink();

  useEffect(() => register(), [register]);

  return (
    <button
      className={className}
      data-test="tenant-cookie-settings-link"
      onClick={openTenantAnalyticsConsentPreferences}
      type="button"
    >
      <Trans i18nKey="marketing:cookieSettings" />
    </button>
  );
}
